if (!String.prototype.format) {
  // The following line will prevent the Compile Warning
  // eslint-disable-next-line
  String.prototype.format = function() {
    const args = arguments;
    return this.replace(/{(\d+)}/g, function(match, number) {
      return typeof args[number] !== 'undefined' ? args[number] : match;
    });
  };
}

if (!String.prototype.toProperCase) {
  // The following line will prevent the Compile Warning
  // eslint-disable-next-line
  String.prototype.toProperCase = function() {
    return this.replace(/\w\S*/g, function(txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  };
}

// http://udidu.blogspot.com/2012/12/override-console-functions.html
// https://github.com/sunnykgupta/jsLogger/blob/master/jsLogger.js

if (!String.prototype.camelize) {
  // The following implement a method to convert the string to CamelCase
  String.prototype.camelize = function () {
    return this.split(' ')
        // get rid of any extra spaces using trim
        .map(a => a.trim())
        // Convert first char to upper case for each word
        .map(a => a[0].toUpperCase() + a.substring(1))
        // Join all the strings back together
        .join("")
  }
}